/**
 * Search Exit Intent Tracking
 * Triggers event when user performs a search
 * Optimized to only run on search-related pages
 */

(function () {
  'use strict';

  let searchTriggered = false;

  function triggerSearchExitIntent() {
    if (searchTriggered) return;
    
    searchTriggered = true;
    console.log('Search detected - triggering exit intent event');

    // Use EventTracker if available, fallback to direct dispatch
    if (window.EventTracker) {
      window.EventTracker.trigger('search_exit_intent', {
        timestamp: new Date().toISOString(),
        page: window.location.pathname,
      }, 5000);
    } else {
      setTimeout(function () {
        if (typeof $ !== 'undefined') {
          $('html').trigger('search_exit_intent');
        } else if (typeof jQuery !== 'undefined') {
          jQuery('html').trigger('search_exit_intent');
        } else if (window.CustomEvent) {
          window.dispatchEvent(new CustomEvent('search_exit_intent', { bubbles: true }));
        }
        console.log('✓ Event triggered: search_exit_intent');
      }, 5000);
    }
  }

  // Detect if already on search results page
  if (window.location.pathname.includes('/search') || window.location.search.includes('q=')) {
    triggerSearchExitIntent();
    return; // Exit early if already on search page
  }

  // Lazy attach event listeners
  let listenersAttached = false;

  function attachSearchListeners() {
    if (listenersAttached) return;
    listenersAttached = true;

    // Detect search form submission
    document.addEventListener('submit', function (e) {
      const form = e.target;
      if (
        form.querySelector('input[type="search"]') ||
        form.querySelector('input[name="q"]') ||
        (form.action && form.action.includes('/search'))
      ) {
        triggerSearchExitIntent();
      }
    });

    // Detect Enter key in search fields
    document.addEventListener('keypress', function (e) {
      if (e.key === 'Enter' || e.keyCode === 13) {
        const target = e.target;
        if (target.type === 'search' || target.name === 'q' || target.closest('form[action*="/search"]')) {
          triggerSearchExitIntent();
        }
      }
    });

    // Detect search button clicks
    document.addEventListener('click', function (e) {
      const target = e.target;
      if ((target.type === 'submit' || target.tagName === 'BUTTON') && target.closest('form[action*="/search"]')) {
        triggerSearchExitIntent();
      }
    });

    console.log('Search listeners attached');
  }

  // Attach listeners on first user interaction (optimized)
  ['mousemove', 'scroll', 'touchstart', 'click'].forEach((event) => {
    document.addEventListener(
      event,
      function () {
        attachSearchListeners();
      },
      { once: true, passive: true }
    );
  });
})();